import React from 'react'
import { useHistory, useLocation } from "react-router-dom";
import {
  DateFilter,
  OrganizationTypeSelect,
  ApproachSelect,
  IssueSelect
} from '../../../components'
import { useDispatch, useSelector } from 'react-redux';
import { useViewport } from '../../../utils';
import { useInternationalization } from '../../../features/i18n';
import { ProvincesProvider } from '../../../features/provinces/hook';
import { setQueryString, emptyAllSelectedCollections } from '../../../features/search/slice';
import useQuery from '../../../features/search/hooks/useQuery';
import { SystemProvider } from '../../../features/system/provider';
import { ProvinceDropdown } from '../../../features/provinces/components/province-dropdown';
import qs from 'query-string'

const MapFilter = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const { config } = useQuery()
  const { translate } = useInternationalization()
  const language = useSelector(state => state.system.language)
  const [showFormTrigger, setShowFormTrigger] = React.useState(true)
  const { isDesktop } = useViewport()
  const showForm = isDesktop && showFormTrigger

  React.useEffect(() => {
    // Refresh form when language changed
    setShowFormTrigger(false)
    setTimeout(() => setShowFormTrigger(true), 250)
  }, [language])

  const {
    selectedApproaches,
    selectedIssues,
    selectedOrganizationTypes,
  } = useSelector(state => state.search);

  const handleEvent = (e) => {
    const { name, value } = e.target;
    const newParams = new URLSearchParams(window.location.search);

    if (config[name]) {
      newParams.delete(config[name].param);

      if (value && value.length > 0) {
        dispatch(config[name].setter(value));

        for (let index = 0; index < value.length; index++) {
          const element = value[index];
          newParams.append(config[name].param, String(element.value));
        }
      } else {
        dispatch(config[name].setter([]));
      }
    }

    history.push(location.pathname + "?" + newParams.toString());
  };

  const handleClear = () => {
    setShowFormTrigger(false)

    dispatch(setQueryString(''))
    dispatch(emptyAllSelectedCollections())

    history.push(location.pathname)

    setTimeout(() => {
      const newShowFormTrigger = isDesktop && true
      setShowFormTrigger(newShowFormTrigger)
    }, 50)
  }

  const handleProvince = (e) => {
    const { name, value } = e.target;
    const newParams = new URLSearchParams(window.location.search);

    if (newParams.has(name)) {
      newParams.delete(name);
    }

    newParams.append(name, String(value.label));

    history.push(location.pathname + "?" + newParams.toString());
  }

  const handleDate = ({maxDate, minDate}) => {
    console.log({maxDate, minDate})
    if(maxDate && minDate){
      const query = qs.parse(location.search)
      const newQuery = {
        ...query,
        startRentangWaktu: minDate,
        endRentangWaktu: maxDate
      }

      history.push({
        pathname: location.pathname,
        search: qs.stringify(newQuery)
      })
    }
  }

  return (
    <SystemProvider>
      {
        showForm &&
        <div className="hidden lg:flex items-center">
          <div style={{minWidth: '160px'}}>
            <div className="mr-2">
              <OrganizationTypeSelect
                defaultValues={selectedOrganizationTypes}
                updateForm={handleEvent}
                label={<></>}
                placeholder={translate('ORGANIZATION', 'singular')}
              />
            </div>
          </div>
          <div style={{minWidth: '160px'}}>
            <div className="mr-2">
              <ApproachSelect
                defaultValues={selectedApproaches}
                updateForm={handleEvent}
                label={<></>}
                placeholder={translate('APPROACH', 'singular')}
              />
            </div>
          </div>
          <div style={{minWidth: '160px'}}>
            <div className="mr-2">
              <IssueSelect
                defaultValues={selectedIssues}
                updateForm={handleEvent}
                label={<></>}
                placeholder={translate('ISSUE', 'plural')}
              />
            </div>
          </div>
          <div style={{minWidth: '160px'}}>
            <div className="mr-2">
              <ProvincesProvider>
                <ProvinceDropdown
                  customLabel={<></>}
                  noMarginBottom={true}
                  updateForm={handleProvince}
                />
              </ProvincesProvider>
            </div>
          </div>
          <div style={{minWidth: '160px'}}>
            <div className="mr-2">
              <DateFilter
                placeholder={translate('SEARCH', 'date')}
                onSubmit={handleDate}
              />
            </div>
          </div>
          <div
            className="underline text-sm ml-8 cursor-pointer"
            style={{minWidth: '94px', color: '#ccc'}}
            onClick={handleClear}
          >
            {translate('SEARCH', 'clear')}
          </div>
        </div>
      }
    </SystemProvider>
  )
}

export default MapFilter

// BACKUP

// const options = [
//   {label: 'NGO', value: 1},
//   {label: 'CSO', value: 2},
//   {label: 'Government', value: 3},
//   {label: 'Donor', value: 4},
//   {label: 'Corporate', value: 5},
// ]

// {
//   showForm &&
//   <div className="flex items-center ">
//     {/* <BasicDropdown
//       placeholder="Organization"
//       options={[]}
//       noMargin
//       className="mr-2"
//     /> */}
//     <div style={{minWidth: '160px'}}>
//       <BasicDropdown
//         options={options}
//         multi
//         noMarginBottom
//         className="mr-2"
//         placeholder={translation.ORGANIZATION.singular[language.name]}
//       />
//     </div>
//     <div style={{minWidth: '160px'}}>
//       <BasicDropdown
//         placeholder={translation.APPROACH.singular[language.name]}
//         options={[]}
//         noMargin
//         className="mr-2"
//         noMarginBottom
//       />
//     </div>
//     <div style={{minWidth: '160px'}}>
//       <BasicDropdown
//         placeholder={translation.ISSUE.plural[language.name]}
//         options={[]}
//         noMargin
//         className="mr-2"
//         noMarginBottom
//       />
//     </div>
//     <div style={{minWidth: '160px'}}>
//       <BasicDropdown
//         placeholder={translation.GENERAL.province[language.name]}
//         options={[]}
//         noMargin
//         className="mr-2"
//         noMarginBottom
//       />
//     </div>
//     <div style={{minWidth: '160px'}} className="relative">
//       {/* <BasicDropdown
//         placeholder={translation.SEARCH.date[language.name]}
//         options={[]}
//         noMargin
//         className="mr-2"
//         noMarginBottom
//       /> */}
//       <DateFilter placeholder={translation.SEARCH.date[language.name]} />
//     </div>
//     <div
//       className="underline text-sm ml-8 cursor-pointer"
//       style={{minWidth: '94px', color: '#ccc'}}
//     >
//       {translation.SEARCH.clear[language.name]}
//     </div>
//   </div>
// }
